<div class="panelLocations"  [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}" id="panelLocationContainer">
  <loading [isLoading]="isLoading"></loading>
  <div class="btnClose">
    <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="ClosePanel()"></mat-icon>
  </div>
  
   <div class="header_panel">
    <h1>Control de Activos</h1>
   </div>

   <div class="search-Arrow-flex">
    <div class="searchBar-flex">
      <div class="searchBar" id="searchLocationInput" mat-tooltip="Buscar por Identificador o Alias" matTooltipPosition="above">
        <mat-form-field class="width-input">
          <input
            #filterGlobal
            [(ngModel)]="globalFinder"
            matInput
            placeholder="Búsqueda por Identificador o Alias"
            spellcheck="false"
            type="text"
            (input)="onGlobalFilter(filterGlobal.value)"
          />
        </mat-form-field>
      </div>
      <div class="btnResetFilter-container" (click)="resetGlobalFilterValue()" *ngIf="globalFinder.length > 0">
        <mat-icon  matTooltip="Borrar" aria-hidden="false" >cancel</mat-icon>
      </div>
      <div class="btnSearch-container" (click)="onGlobalFilterButton(filterGlobal.value)">
        <img class="btnSearchIcon" src="/assets/img/icon_search.png" width="25px">
      </div>
    </div>
    
    <div *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_up</mat-icon>
    </div>
    <div *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_down</mat-icon>
    </div>
   </div>

  <div class="button-tool-list" id="panelLocationButtonToolContainer">
    <div class="col-10">
      <!-- [AvailabilityFiltersObject]="AvailabilityFiltersObject"
      [ApplyAvailabilityFilter]="ApplyAvailabilityFilter"
      (availabilityFilterResponse)="availabilityFilterResponse($event)" -->
      <location-button-toolbar [isGlobal] = "true"
      [btnDownExcel]="true" 
      [isLocationFilter]="isGlobalFilterActive" 
      [filterLocationList]="vinsFilterGlobal" 
      [excelDownloadOperation]="excelDownloadOperation"
      [idLocationCategory]="selectedCategoryItem ? selectedCategoryItem.id : 0"
      [filtersObject]="filtersObject"
      [ApplyFilter]="ApplyFilter"
      (filterResponse)="filterResponse($event)"></location-button-toolbar>
    </div>

    <div class="col-2">
      <app-report-list id="panelLocationReportsButton" [isGlobal] = "true">
        </app-report-list>
      <!-- <div class="tool-option" > </div> -->
    </div>
  </div>

   <div class="center-item filter-list" *ngIf="isGlobalFilterActive">
    <div class="center-item">
      <div class="section-header-background">
        <h3>Resultado de búsqueda </h3> 
      </div>
    </div>
    <div class="control-items">
      <h3 *ngIf="$itemsFilterGlobal == 0 && !isLoading">No se encontraron elementos</h3>
      <!-- el ngclass cambia el color de las tarjetas (se puede haer más dinámico, sólo falta saber que nombre tienen en la base)-->
      <!-- <div class="itemPanel" [ngClass]="{'engineerActive': item.location.idLocationCategory == this.enumLocationCategories.Engineer, 'ServiceActive': item.location.idLocationCategory == this.enumLocationCategories.Service}" *ngFor="let item of $itemsFilterGlobal" (click)="onCardClicked(item.location)"></div> -->
      <div class="itemPanel" *ngFor="let item of $itemsFilterGlobal" (click)="onCardClicked(item.location)">
        <div class="row itemPanel-flex">
          <!-- <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
            GBR
          </div> -->
          <div class="item-left">
            <!-- <img class="item-icon" [src]="'/assets/img/' + item.icon" width="25px"> -->
            <img class="item-icon" [src]="item.location.panelIcon | findUrl" width="25px">
          </div>
          <div class="row-item item-right">
            <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
              <mat-chip-set class="status-flag-set-locations">
                <mat-chip  *ngFor="let flag of item.statusFlags" class="status-flag" [style.background-color]="flag.priorityHex + '33'" [style.border]="'2px solid ' + flag.priorityHex">
                  {{flag.flagName}}
                </mat-chip>
              </mat-chip-set>
            </div>
            <label [ngClass]="{'title-item-act': item.tipo == 'Actualizado', 'title-item-des': item.tipo == 'Desactualizado', 'title-item-off': item.tipo == 'Desconectado' }">
              <strong>{{item.location.identifier}}</strong>
            </label>
            <label class="subtitle-item"><strong>{{item.location.description}}</strong></label>
            <label class="subtitle-item"><strong>{{item.location.alias}}</strong></label>
          </div>
          <div class="copy-to-clipboard" (click)="copyToClipboard(item.location.identifier); $event.stopPropagation()">
            <mat-icon>content_copy</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
    <div class="locations-tab-group">
      <mat-tab-group mat-stretch-tabs (selectedTabChange)="selectTab($event)" *ngIf="!isGlobalFilterActive" id="panelLocationTabContent">
        <!-- tab de actualizados -->
      
       <mat-tab *ngIf="isVisibleGPSTabs" [label]="1">
         <ng-template mat-tab-label >
          <div id="panelLocationActiveTab">
            <label class="gps-label">GPS</label>
            <label  matTooltip="Activos que se actualizaron en las últimas 12 horas." matTooltipPosition="above">
           <img src="/assets/img/icon_activos.png" width="25px">
            {{totalActualizados}} Online 
            </label>
          </div> 
         </ng-template>
         <ng-template matTabContent >
            <div class="section-footer-background"></div>
               <div *ngIf="selectedTabIndex == 1" class="tab-content-wrapper" (scroll)="onScroll($event)">
               <div class="control-items">
                 <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
                   <div class="row itemPanel-flex">
                    <!-- esta hardcodeado para gbr, pero se puede agregar para cualquiera -->
                    <!-- <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                      GBR
                    </div> -->
                     <div class="item-left">
                       <img class="item-icon" [src]="item.panelIcon | findUrl" width="25px">
                     </div>
                     <div class="row-item item-right">
                      <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                        <mat-chip-set class="status-flag-set-locations">
                          <mat-chip  *ngFor="let flag of item.statusFlags" class="status-flag" [style.background-color]="flag.priorityHex + '33'" [style.border]="'2px solid ' + flag.priorityHex">
                            {{flag.flagName}}
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                      <label class="title-item-act"><strong>{{item.identifier}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.alias}}</strong></label>
                     </div>
                     <div class="copy-to-clipboard" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                        <mat-icon>content_copy</mat-icon>
                      </div>
                   </div>
                 </div>

                 <div class="row itemPanel" *ngIf="$Items.length == 0 && !isLoading">
                   <div class="row-item ">
                     <label class="title-item"><strong> No se encontraron resultados</strong></label>
                   </div>
                 </div>
               </div>
             </div>
         </ng-template>
       </mat-tab>
       <!-- tab desactualizados -->
       <mat-tab *ngIf="isVisibleGPSTabs" [label]="2" >
         <ng-template mat-tab-label>
          <div id="panelLocationInactiveTab">
            <label class="gps-label">GPS</label>
            <label matTooltip="Activos que NO se actualizaron en las últimas 12 horas." matTooltipPosition="above">
              <img src="/assets/img/icon_offline.png" width="25px">
              {{totalDesactualizados}}  Offline 
            </label> 
          </div>
         </ng-template>
         <ng-template matTabContent>
          <div class="section-footer-background"></div>
           <div *ngIf="selectedTabIndex == 2" class="tab-content-wrapper" (scroll)="onScroll($event)">
           <div class="control-items">
             <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
               <div class="row itemPanel-flex">
                 <div class="item-left">
                   <img class="item-icon" [src]="item.panelIcon | findUrl" width="25px">
                 </div>
                 <div class="row-item item-right">
                  <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                    <mat-chip-set class="status-flag-set-locations">
                      <mat-chip  *ngFor="let flag of item.statusFlags" class="status-flag" [style.background-color]="flag.priorityHex + '33'" [style.border]="'2px solid ' + flag.priorityHex">
                        {{flag.flagName}}
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                   <label class="title-item-des"><strong>{{item.identifier}}</strong></label>
                   <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                   <label class="subtitle-item"><strong>{{item.alias}}</strong></label>
                 </div>
                 <div class="copy-to-clipboard" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                    <mat-icon>content_copy</mat-icon>
                  </div>
               </div>
             </div>
             <div class="row itemPanel" *ngIf="$Items.length == 0 && !isLoading">
               <div class="row-item col-md-12">
                 <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
               </div>
             </div>
           </div>
         </div>
         </ng-template>
       </mat-tab>
         <!-- tab sin reporte -->
       <mat-tab *ngIf="isVisibleGPSTabs" [label]="3">
         <ng-template mat-tab-label>
          <div id="panelLocationDisconectedTab">
            <label class="gps-label">GPS</label>
            <label matTooltip="Activos que NO han presentado actualización de GPS." matTooltipPosition="above">
              <img src="/assets/img/icon_sinseñal.png" width="25px">
            {{(totalSinReporte)}} S/R
            </label>
          </div>
         </ng-template>
         <ng-template matTabContent>
          <div class="section-footer-background"></div>
               <div *ngIf="selectedTabIndex == 3" class="tab-content-wrapper" (scroll)="onScroll($event)">
               <div class="control-items">
                 <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
                   <div class="row itemPanel-flex">
                    <!-- esta hardcodeado para gbr, pero se puede agregar para cualquiera -->
                    <!-- <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                      GBR
                    </div> -->
                     <div class="item-left">
                       <img class="item-icon" [src]="item.panelIcon | findUrl" width="25px">
                     </div>
                     <div class="row-item item-right">
                      <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                        <mat-chip-set class="status-flag-set-locations">
                          <mat-chip  *ngFor="let flag of item.statusFlags" class="status-flag" [style.background-color]="flag.priorityHex + '33'" [style.border]="'2px solid ' + flag.priorityHex">
                            {{flag.flagName}}
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                      <label class="title-item-off"><strong>{{item.identifier}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.alias}}</strong></label>
                     </div>
                     <div class="copy-to-clipboard" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                      <mat-icon>content_copy</mat-icon>
                    </div>
                   </div>
                 </div>

                 <div class="row itemPanel" *ngIf="$Items.length == 0 && !isLoading">
                   <div class="row-item ">
                     <label class="title-item"><strong> No se encontraron resultados</strong></label>
                   </div>
                 </div>
               </div>
             </div>
         </ng-template>
       </mat-tab>
   
       <!-- tabs de categorias dinámico-->
        
        <div *ngFor="let categoryItem of categories; let i = index">
          <mat-tab  *ngIf="categoryItem.isVisible"  class="categoryTabLabel" [label]="(i + 4)" (scroll)="onScroll($event)">
            <ng-template mat-tab-label>
              <img [src]="categoryItem.category.panelIcon | findUrl" width="30px" class="mr-5"> 
              <label matTooltipPosition="above">
                {{categoryItem.total}} {{categoryItem.category.shortName}}
              </label> 
            </ng-template>

            <ng-template matTabContent>
              <div class="section-footer-background"></div>
              <div class="tab-content-wrapper" (scroll)="onScroll($event)">
              
              <div class="control-items">
                <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
                  <div class="row itemPanel-flex">
                    <div class="item-left">
                      <img class="item-icon" [src]="item.panelIcon | findUrl" width="25px">
                    </div>
                    <div class="row-item item-right">
                      <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                        <mat-chip-set class="status-flag-set-locations">
                          <mat-chip  *ngFor="let flag of item.statusFlags" class="status-flag" [style.background-color]="flag.priorityHex + '33'" [style.border]="'2px solid ' + flag.priorityHex">
                            {{flag.flagName}}
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                      <label class="title-item-act"><strong>{{item.identifier}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                    </div>
                  </div>
                  <div class="copy-to-clipboard" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                    <mat-icon>content_copy</mat-icon>
                  </div>
                </div>
                <div class="row itemPanel" *ngIf="$Items.length == 0 && !isLoading">
                  <div class="row-item col-md-12">
                    <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
                  </div>
                </div>
              </div>
            </div>
            </ng-template>
          </mat-tab>
        </div>
        
        
     </mat-tab-group>
    </div>

    <div class="">
      <div class="section-footer-background">
      </div>
    </div>

</div>
